const common = {
  no_data_title: 'No data found',
  no_data_description: 'There are no records to display.',
  loading: 'Loading...',
  error: 'An error occurred',
  success: 'Operation completed successfully',
  confirm: 'Confirm',
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  create: 'Create',
  search: 'Search',
  filter: 'Filter',
  export: 'Export',
  help: 'Help',
  filters: {
    label: 'Filters',
    show: 'Show filters',
    hide: 'Hide filters',
  },
  clear: 'Clear',
  yes: 'Yes',
  no: 'No',
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
  },
  notifications: {
    session_extended_success: 'Session extended successfully',
    session_expired: 'Your session has expired. Please log in again.',
    connection_error: 'Connection error. Please check your internet connection.',
    server_error: 'Server error. Please try again later.',
    save_success: 'Data saved successfully',
    save_error: 'Error saving data',
    delete_success: 'Item deleted successfully',
    delete_error: 'Error deleting item',
  },
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    minLength: 'Must be at least %{min} characters',
    maxLength: 'Must be no more than %{max} characters',
    number: 'Must be a valid number',
    positive: 'Must be a positive number',
    unique: 'This value already exists',
  },
};

export default common;
